export const COLOR_NOT_FOUND = 'ff00f6'

export const HEADER_HEIGHT = '56px'
